export const PricingSectionCss = {
  main: {
    display: "flex",
    alignItems: "center",
    paddingTop: "50px",
    paddingBottom: "50px",
    backgroundColor: "#000",
    color: "#fff"
  },
  heading: {
    margin: "0 0 35px"
  }
};
